import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Modal, Space } from "antd";
import { createStyles, useTheme } from "antd-style";

const useStyle = createStyles(({ token }) => ({
  "my-modal-body": {
    background: token.red1,
    padding: token.paddingSM,
  },
  "my-modal-mask": {
    boxShadow: `inset 0 0 15px #fff`,
  },
  "my-modal-header": {
    borderBottom: `1px dotted ${token.colorPrimary}`,
  },
  "my-modal-footer": {
    color: token.colorPrimary,
  },
  "my-modal-content": {
    border: "1px solid #333",
  },
}));
const CandidateAssessmentModal = ({
  isModalOpen,
  toggleModal,
  handleFinish,
}) => {
  const { styles } = useStyle();
  const token = useTheme();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    let timer;
    if (isModalOpen?.fullScreenWarning || isModalOpen?.faceDetectionWarning) {
      // Reset countdown when modal opens
      setCountdown(10);
      timer = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (isModalOpen?.faceReacquired) {
            return prevCountdown;
          }
          if (prevCountdown <= 0) {
            clearInterval(timer);
            if (
              isModalOpen?.faceDetectionWarning &&
              isModalOpen?.faceDetectionWarningCount.noFaceWarningCount >
                isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount
            ) {
              handleFinish("Proctoring Fail Empty Video");
            } else if (
              isModalOpen?.faceDetectionWarning &&
              isModalOpen?.faceDetectionWarningCount.noFaceWarningCount <
                isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount
            ) {
              handleFinish("Proctoring Fail Many");
            } else if (
              isModalOpen?.fullScreenWarning &&
              isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount >
                isModalOpen?.fullScreenWarningCount.minBrowserWarningCount
            ) {
              handleFinish("Proctoring Fail OutBrowser");
            } else if (
              isModalOpen?.fullScreenWarning &&
              isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount <
                isModalOpen?.fullScreenWarningCount.minBrowserWarningCount
            ) {
              handleFinish("Proctoring Fail MaxBrowser");
            }
            // Here you can add logic for when the timer runs out,
            // for example, ending the assessment.
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [isModalOpen]);

  const classNames = {
    body: styles["my-modal-body"],
    mask: styles["my-modal-mask"],
    header: styles["my-modal-header"],
    footer: styles["my-modal-footer"],
    content: styles["my-modal-content"],
  };
  const modalStyles = {
    header: {
      borderLeft: `5px solid ${token.colorError}`,
      borderRadius: 0,
      paddingInlineStart: 5,
    },
    body: {
      boxShadow: "inset 0 0 5px #999",
      borderRadius: 5,
    },
    mask: {
      backdropFilter: "blur(10px)",
    },

    content: {
      boxShadow: "0 0 30px #999",
    },
  };

  const handleOk = () => {
    document.documentElement.requestFullscreen();
    toggleModal("fullScreenWarning", "outOfFocusWarning", false);
  };

  const ModalMessage = () => {
    // Check if the face detection warning modal is active
    if (isModalOpen?.faceDetectionWarning) {
      // Face was reacquired - let the user know they're safe, and hold
      // this message for the grace period instead of instantly vanishing.
      if (isModalOpen?.faceReacquired) {
        return (
          <span>
            Face detected again. This warning will close automatically.
            <br />
            Warning Count :{" "}
            {isModalOpen?.faceDetectionWarningCount.noFaceWarningCount +
              isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount}
            /3
          </span>
        );
      }
      if (
        isModalOpen?.faceDetectionWarningCount.noFaceWarningCount +
          isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount <=
        3
      ) {
        return (
          <span>
            No face or multiple faces detected. Please position yourself
            correctly so that only you are visible in the camera frame within
            the next {countdown} seconds.
            <br />{" "}
            <b>
              (
              {isModalOpen?.faceDetectionWarningCount.noFaceWarningCount +
                isModalOpen?.faceDetectionWarningCount
                  .multiFacesWarningCount}{" "}
              of 3 warnings used)
            </b>
          </span>
        );
      } else {
        return (
          <span>Face Detection Violations, Your assessment has been ended</span>
        );
      }
    }

    // If face detection is not active, check if the full screen warning modal is active
    else if (isModalOpen?.fullScreenWarning) {
      if (
        isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount +
          isModalOpen?.fullScreenWarningCount.minBrowserWarningCount <=
        3
      ) {
        return (
          <span>
            You have left the assessment window. Please return within{" "}
            {countdown} seconds else your test will be ended.
            <br />{" "}
            <b>
              (
              {isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount +
                isModalOpen?.fullScreenWarningCount.minBrowserWarningCount}{" "}
              of 3 warnings used)
            </b>
          </span>
        );
      } else {
        return (
          <span>
            You exceeded the maximum number of violations (3). Your attempt has
            been ended.
          </span>
        );
      }
    }

    // Return null if no relevant modal is open, to prevent rendering anything
    return "warning bro";
  };

  return (
    <>
      <Modal
        title="Warning"
        open={
          isModalOpen?.fullScreenWarning || isModalOpen?.faceDetectionWarning
        }
        onOk={
          isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount > 3 ||
          isModalOpen?.fullScreenWarningCount.minBrowserWarningCount > 3 ||
          isModalOpen?.faceDetectionWarningCount.noFaceWarningCount > 3 ||
          isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount > 3
            ? handleFinish
            : handleOk
        }
        classNames={classNames}
        styles={modalStyles}
        okText={
          isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount > 3 ||
          isModalOpen?.fullScreenWarningCount.minBrowserWarningCount > 3 ||
          isModalOpen?.faceDetectionWarningCount.noFaceWarningCount > 3 ||
          isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount > 3
            ? "End Assessment"
            : "Return to Fullscreen"
        }
        okButtonProps={{
          style:
            isModalOpen?.faceDetectionWarningCount.noFaceWarningCount +
              isModalOpen?.faceDetectionWarningCount.multiFacesWarningCount >
              3 ||
            isModalOpen?.fullScreenWarningCount.outOfFocusWarningCount +
              isModalOpen?.fullScreenWarningCount.minBrowserWarningCount >
              3 ||
            isModalOpen?.faceDetectionWarning
              ? { display: "none" }
              : {},
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
        maskClosable={false}
        keyboard={false}
      >
        <ModalMessage />
      </Modal>
    </>
  );
};
export default CandidateAssessmentModal;
